import { staticContentRoutes } from './static/static-content-routes'
import { customTopicRoutes } from './topic/custom-topic-routes'
import { liveScoresRoute } from './custom/get-live-scores-route-info'

import { homepage } from './home'
import { regionalRoutes } from './regionals'
import { westlive } from './west-live'
import { StaticRoutes } from '@news-mono/web-common'
import { TheWestSection } from '@news-mono/component-library'
import { getYourStoryOurStoryRouteInfo } from './features/your-story-our-story'
import { getLisaGovanRouteInfo } from './features/lisa-govan'
import { getNewsletterSubscriptionRouteInfo } from './newsletter-subscription/newsletter-subscription'

export const staticRoutes: StaticRoutes<TheWestSection> = {
    ...staticContentRoutes,
    ...customTopicRoutes,
    ...homepage,
    ...liveScoresRoute,
    ...regionalRoutes,
    ...westlive,
    ...getYourStoryOurStoryRouteInfo,
    ...getLisaGovanRouteInfo,
    ...getNewsletterSubscriptionRouteInfo,
}
